import styled from 'styled-components'

const InfoText = styled.p`
  margin: 1rem;
`
const GreenText = styled.span`
  color: green;
  font-weight: 600;
`

const Health = (): JSX.Element => {
  return (
    <InfoText>
      The app is <GreenText>healthy</GreenText>
    </InfoText>
  )
}

export default Health
